import dateFormat from "dateformat";
import moment from "moment";
import React, { Component } from "react";
import Barcode from "react-barcode";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Currency from "react-currency-formatter";
import TagManager from "react-gtm-module";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import ReactTooltip from "react-tooltip";
import api from "services/api";
import firebase from "services/firebase";
import { normalizeBillStatus } from "utils/functions";
import {
  BackButton,
  BankSlipContainer,
  BarcodeContainer,
  BarcodeContent,
  BarcodeResponsive,
  CloseIcon,
  Container,
  Content,
  CustomerInfoContainer,
  DetailsContainer,
  DetailsContent,
  DuplicateButton,
  DuplicateContainer,
  DuplicateIcon,
  DuplicateLoading,
  DuplicateText,
  Header,
  Hr,
  Info,
  InfoText,
  InfoTitle,
  InvoiceNumber,
  Left,
  Link,
  RemoveSpace,
  SectionTitle,
  StatusContainer,
  StatusIcon,
  StatusText,
  Title,
  ToolTipButton,
  ToolTipText,
  TypeableLineContainer,
  TypeableLineIcon,
  DetailsWrapper
} from "./styles";
import ExpiredBillBanner from "components/ExpiredBillBanner";

class Boletos extends Component {
  constructor() {
    super();
    this.state = {
      token: null,
      payment: [],
      installment: {},
      customer: {},
      invoice: {},
      loading: false,
      loadingDownload: false,
      loadingEmail: false,
      status: null,
      customerType: localStorage.getItem("@UltragazEmpresarial:customerType")
    };
  }

  componentDidMount() {
    const { payment, installment } = this.props;
    this.organizeData(payment, installment);
    this.handleStatus(installment);
  }

  organizeData = async (payment, installment) => {
    this.setState({ loading: true });
    const customer = payment.customer;
    const invoice = payment;
    return await this.setState({
      token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
      invoice,
      customer,
      installment
    });
  };

  convertLine = dados => {
    dados = (dados || "").replace(/\s+/g, "");
    if (dados.length <= 47) {
      const line = `${dados}`;
      const bank = line.substring(0, 3);
      const coin = line.substring(3, 4);
      const camp = line.substring(4, 9);
      const camp2 = line.substring(10, 20);
      const camp4 = line.substring(21, 31);
      const camp6 = line.substring(32, 47);
      const result = bank + coin + camp6 + camp + camp2 + camp4;
      return result;
    }
    if (dados.length === 48) {
      const line = `${dados}`;
      const camp = line.substring(0, 11);
      const camp1 = line.substring(12, 23);
      const camp2 = line.substring(24, 35);
      const camp3 = line.substring(36, 47);
      return camp + camp1 + camp2 + camp3;
    }
  };

  handleStatus = installment => {
    const normalizedStatus = normalizeBillStatus(
      installment.status,
      this.state.invoice?.totalAmount
    );
    this.setState({ status: normalizedStatus });
  };

  requestDownloadBoletoGranel = () => {
    this.setState({ loadingDownload: true });
    const { customer, invoice, installment, token } = this.state;
    this.analyticsDownloadBoleto();
    const header = {
      "Content-Type": "application/json",
      access_token: token
    };
    const parameters = {
      method: "POST",
      responseType: "blob",
      headers: header
    };
    const contactIdSf = localStorage.getItem(
      "@UltragazEmpresarial:contactIdSf"
    );
    const body = {
      customerCode: customer.code,
      customerSiteCode: customer.siteCode,
      deliveryMethod: "DOWNLOAD",
      ...(contactIdSf && { contactIdSf: contactIdSf })
    };
    api
      .post(
        `industrial/invoice/v1/invoices/${invoice.invoiceId}/installments/${installment.installmentId}/bankslips`,
        body,
        parameters
      )
      .then(blob => {
        // 2. Create blob link to download
        const url = window.URL.createObjectURL(new Blob([blob.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${this.state.installment.installmentId}.pdf`
        );
        // 3. Append to html page
        document.body.appendChild(link);
        // 4. Force download
        link.click();
        // 5. Clean up and remove the link
        link.parentNode.removeChild(link);
        this.setState({ loadingDownload: false });
      })
      .catch(err => {
        this.setState({ loadingDownload: false });
        const erro = err.response.data;
        if (erro) {
          const message = err.response.data.message;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else {
          if (err.response.status !== 401) {
            toast.error("Ocorreu um erro interno na aplicação");
          }
        }
      });
  };

  requestEmailBoletoGranel = () => {
    this.analisticsEmailBoleto();
    this.setState({ loadingEmail: true });
    try {
      const { customer, invoice, installment, token } = this.state;
      const header = {
        "Content-Type": "application/json",
        access_token: token
      };
      const parameters = {
        method: "POST",
        headers: header
      };
      const contactIdSf = localStorage.getItem(
        "@UltragazEmpresarial:contactIdSf"
      );
      const body = {
        customerCode: customer.code,
        customerSiteCode: customer.siteCode,
        deliveryMethod: "EMAIL",
        ...(contactIdSf && { contactIdSf: contactIdSf })
      };
      api
        .post(
          `industrial/invoice/v1/invoices/${invoice.invoiceId}/installments/${installment.installmentId}/bankslips`,
          body,
          parameters
        )
        .then(res => {
          this.setState({ loadingEmail: false });
          toast.success(`Boleto enviado para o e-mail cadastrado`);
        })
        .catch(err => {
          this.setState({ loadingEmail: false });
        });
    } catch (err) {
      this.setState({ loadingEmail: false });
      if (err.response) {
        const erro = err.response.data;
        if (erro) {
          const message = err.response.data.message;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else {
          if (err.response.status !== 401) {
            toast.error("Ocorreu um erro interno na aplicação");
          }
        }
      } else {
        toast.error("Ocorreu um erro interno na aplicação");
      }
    }
  };

  requestDownloadBoletoMi = async () => {
    this.analyticsDownloadBoleto();
    this.setState({ loadingDownload: true });
    try {
      const headers = {
        access_token: this.state.token
      };
      const body = {
        deliveryMethod: "DOWNLOAD",
        email: localStorage.getItem("@UltragazEmpresarial:loginEmail"),
        isReduced: false
      };
      const response = await api.post(
        `industrial/bill/v1/bills/${this.state.invoice.id}`,
        body,
        { headers, responseType: "blob" }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      const referenceMonth = (
        this.state.installment.referenceMonth || ""
      ).split("/");
      link.setAttribute(
        "download",
        `Ultragaz_${(
          dateFormat(
            parseInt(referenceMonth[1]) + "/" + "01" + "/" + referenceMonth[0],
            "mmmyyyy"
          ) || ""
        ).toUpperCase()}_${this.state.invoice.id}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      this.setState({ loadingDownload: false });
    } catch (err) {
      this.setState({ loadingDownload: false });
      if (err.response) {
        const erro = err.response.data;
        if (erro) {
          const message = err.response.data.message;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else {
          if (err.response.status !== 401) {
            toast.error("Ocorreu um erro interno na aplicação");
          }
        }
      } else {
        toast.error("Ocorreu um erro interno na aplicação");
      }
    }
  };

  requestEmailBoletoMi = async () => {
    toast.dismiss();
    this.analisticsEmailBoleto();
    this.setState({ loadingEmail: true });
    try {
      const headers = {
        access_token: this.state.token
      };

      const response = await api.get(`industrial/customer/v1/customers/me`, {
        headers
      });
      const { data } = response;
      const { email } = data;

      if (!email) {
        toast.error(
          "Não foi possível enviar o e-mail, por favor verifique em dados cadastrais se possui um email cadastrado e validado"
        );
        this.setState({ loadingEmail: false });
        return;
      }

      const body = {
        deliveryMethod: "EMAIL",
        email
      };
      await api.post(
        `industrial/bill/v1/bills/${this.state.invoice.id}`,
        body,
        { headers }
      );
      toast.success(`Boleto enviado para o e-mail: ${email}`);
      this.setState({ loadingEmail: false });
    } catch (err) {
      this.setState({ loadingEmail: false });
      if (err.response) {
        const erro = err.response.data;
        if (erro) {
          const message = err.response.data.message;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else {
          if (err.response.status !== 401) {
            toast.error("Ocorreu um erro interno na aplicação");
          }
        }
      } else {
        toast.error("Ocorreu um erro interno na aplicação");
      }
    }
  };

  requestDownloadBoleto = () => {
    if (this.state.customerType === "Granel") {
      this.requestDownloadBoletoGranel();
    }
    if (this.state.customerType === "MI") {
      this.requestDownloadBoletoMi();
    }
  };

  requestEmailBoleto = () => {
    if (this.state.customerType === "Granel") {
      this.requestEmailBoletoGranel();
    }
    if (this.state.customerType === "MI") {
      this.requestEmailBoletoMi();
    }
  };

  handleCopyToClickBoard = copyId => {
    this.setState({
      copyId
    });
  };

  getStatusColor = (status = "") => {
    status = status ? status : "";
    status = status.replace("_", " ").toLocaleLowerCase();
    return status === "pago"
      ? "#75B943"
      : status === "vencido"
      ? "#e34e2a"
      : status === "a vencer"
      ? "#f0b01b"
      : "#000";
  };

  analisticsEmailBoleto() {
    firebase.analytics().logEvent("email_boleto", {
      customerCode: localStorage.getItem("@UltragazEmpresarial:customerCode"),
      userEmail: localStorage.getItem("@UltragazEmpresarial:loginEmail")
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        email_boleto: {
          customerCode: localStorage.getItem(
            "@UltragazEmpresarial:customerCode"
          ),
          userEmail: localStorage.getItem("@UltragazEmpresarial:loginEmail")
        }
      }
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        email_boleto: {
          customerCode: localStorage.getItem(
            "@UltragazEmpresarial:customerCode"
          ),
          userEmail: localStorage.getItem("@UltragazEmpresarial:loginEmail")
        }
      }
    });
  }

  analyticsDownloadBoleto() {
    firebase.analytics().logEvent("download_boleto", {
      customerCode: localStorage.getItem("@UltragazEmpresarial:customerCode"),
      userEmail: localStorage.getItem("@UltragazEmpresarial:loginEmail")
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        download_boleto: {
          customerCode: localStorage.getItem(
            "@UltragazEmpresarial:customerCode"
          ),
          userEmail: localStorage.getItem("@UltragazEmpresarial:loginEmail")
        }
      }
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        download_boleto: {
          customerCode: localStorage.getItem(
            "@UltragazEmpresarial:customerCode"
          ),
          userEmail: localStorage.getItem("@UltragazEmpresarial:loginEmail")
        }
      }
    });
  }

  formatDate(date) {
    return new Intl.DateTimeFormat('pt-BR').format(new Date(`${date}T00:00:00`));
  }

  render() {
    const { close, back } = this.props;
    const {
      installment,
      customer,
      invoice,
      copyId,
      loading,
      loadingDownload,
      loadingEmail,
      customerType
    } = this.state;
    const [lastConsumption] = invoice.historicalConsumptions || [];
    return (
      <Container>
        <Header>
          <Left>
            {back ? (
              <BackButton title="Fechar" className="mdi mdi-arrow-left" />
            ) : null}
            <DetailsWrapper>
              <Title>Detalhes do Boleto</Title>
              {this.state.status === "VENCIDO" && (
                <ExpiredBillBanner />
              )}
            </DetailsWrapper>
          </Left>
          <CloseIcon title="Fechar" className="mdi mdi-close" onClick={close} />
        </Header>
        <Content>
          <CustomerInfoContainer>
            <Info>
              <InfoTitle>Cliente:</InfoTitle>
              <InfoText>
                {customerType === "Granel"
                  ? customer.name || ""
                  : invoice.customerName || ""}
              </InfoText>
            </Info>
            <Info className="mt-2">
              <InfoTitle>Endereço:</InfoTitle>
              <InfoText>
                {customerType === "Granel"
                  ? `${customer.address}, ${customer.addressNumber} - ${customer.county}
                    , ${customer.city} - ${customer.stateCode}`
                  : invoice.customerAddress}
              </InfoText>
            </Info>
          </CustomerInfoContainer>
          <Hr />
          <DetailsContainer>
            <SectionTitle>Detalhes</SectionTitle>
            <DetailsContent payDate={installment.paymentDate}>
              <Info>
                <InfoTitle>
                  {" "}
                  {customerType === "Granel"
                    ? "Número da Nota:"
                    : "Número do Boleto:"}
                </InfoTitle>
                {customerType === "Granel" ? (
                  <Link
                    to={`/notas?invoice-number=${this.props.payment.invoiceNumber}`}
                  >
                    <InvoiceNumber>{invoice.invoiceNumber}</InvoiceNumber>
                  </Link>
                ) : (
                  <InvoiceNumber mi>{invoice.invoiceNumber}</InvoiceNumber>
                )}
              </Info>
              <Info>
                <InfoTitle>Leitura Inicial:</InfoTitle>
                <InfoText>
                  {lastConsumption && lastConsumption.initialMeasurement}
                </InfoText>
              </Info>
              <Info>
                <InfoTitle>Leitura Final:</InfoTitle>
                <InfoText>
                  {lastConsumption && lastConsumption.finalMeasurement}
                </InfoText>
              </Info>
              <Info>
                <InfoTitle>Vencimento:</InfoTitle>
                <InfoText>
                  {moment(installment.dueDate).format("DD/MM/YYYY")}
                </InfoText>
              </Info>
              <Info>
                <InfoTitle>Valor:</InfoTitle>
                <InfoText>
                  {installment.amountOriginal ? (
                    <Currency
                      quantity={installment.amountOriginal}
                      currency="BRL"
                      locale="pt"
                    />
                  ) : (
                    `R$ ${installment.totalAmount}`
                  )}
                </InfoText>
              </Info>
              <Info>
                <InfoTitle>Status:</InfoTitle>
                <StatusContainer>
                  <StatusIcon color={this.getStatusColor(this.state.status)} />
                  <StatusText>
                    {(this.state.status || "").replace("_", " ")}
                  </StatusText>
                </StatusContainer>
              </Info>
              {installment.paymentDate &&
              <Info>
                <InfoTitle>Data de pagamento:</InfoTitle>
                <InfoText>
                  {this.formatDate(installment.paymentDate)}
                </InfoText>
              </Info>}

            </DetailsContent>
            {this.state.status !== "PAGO" ? (
              <>
                <Hr />
                <BankSlipContainer>
                  <SectionTitle>Boleto de Cobrança</SectionTitle>
                  <Info style={{ marginTop: "10px" }}>
                    <InfoTitle>Linha Digitável:</InfoTitle>
                    <TypeableLineContainer>
                      <InfoText>{installment.typeableLine}</InfoText>
                      <CopyToClipboard text={installment.typeableLine}>
                        <ToolTipButton
                          onClick={() =>
                            this.handleCopyToClickBoard(
                              installment.typeableLine
                            )
                          }
                          data-tip
                          data-for="copy"
                        >
                          <TypeableLineIcon className="mdi mdi-content-copy" />
                        </ToolTipButton>
                      </CopyToClipboard>
                      {copyId === installment.typeableLine ? (
                        <ReactTooltip id="copy" place="right" effect="solid">
                          <ToolTipText>Copiado</ToolTipText>
                        </ReactTooltip>
                      ) : (
                        <ReactTooltip
                          id="copy"
                          place="right"
                          type="dark"
                          effect="solid"
                        >
                          <ToolTipText>Clique para copiar</ToolTipText>
                        </ReactTooltip>
                      )}
                    </TypeableLineContainer>
                  </Info>
                  <BarcodeContainer className="mt-2">
                    <Info>
                      <InfoTitle>Código de Barras:</InfoTitle>
                      <BarcodeContent>
                        {installment.typeableLine && (
                          <Barcode
                            format={"ITF"}
                            displayValue={false}
                            width={1}
                            height={70}
                            background="#ffffff"
                            style={{ width: "100%" }}
                            value={this.convertLine(installment.typeableLine)}
                          />
                        )}
                      </BarcodeContent>
                      <BarcodeResponsive>
                        {installment.typeableLine && (
                          <Barcode
                            format={"ITF"}
                            displayValue={false}
                            width={0.6}
                            height={70}
                            background="#ffffff"
                            value={this.convertLine(installment.typeableLine)}
                          />
                        )}
                      </BarcodeResponsive>
                    </Info>
                  </BarcodeContainer>

                  <Hr />

                  <DuplicateContainer>
                    <DuplicateText>2ª via de boleto</DuplicateText>
                    <DuplicateButton
                      onClick={() => this.requestDownloadBoleto()}
                    >
                      {loadingDownload ? (
                        <DuplicateLoading className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                      ) : (
                        <DuplicateIcon
                          className="mdi mdi-cloud-download-outline"
                          aria-label="Donwload do boleto"
                        />
                      )}
                    </DuplicateButton>
                    <DuplicateButton onClick={() => this.requestEmailBoleto()}>
                      {loadingEmail ? (
                        <DuplicateLoading className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                      ) : (
                        <DuplicateIcon
                          className="mdi mdi-email-outline"
                          aria-label="Enviar boleto por email"
                        />
                      )}
                    </DuplicateButton>
                  </DuplicateContainer>
                </BankSlipContainer>
              </>
            ) : (
              <RemoveSpace />
            )}
          </DetailsContainer>
        </Content>
      </Container>
    );
  }
}

export default connect()(Boletos);
